import CacheHealth from './interfaces/CacheHealth';
import CacheMessage from './interfaces/CacheMessage';
import CacheInstallationState from './interfaces/CacheInstallationState';
import CacheStatus from './interfaces/CacheStatus';
import { installServiceWorkerCache } from './installServiceWorkerCache';
import logServiceWorkerOptics from './logServiceWorkerOptics';
import updateCacheDiagnostics from './updateCacheDiagnostics';
import { trace } from 'owa-trace';

export function onChecking(message: CacheMessage) {
    trace.info('[SW Client] Checking');
}

export function onDownloading(message: CacheMessage) {
    trace.info('[SW Client] Downloading');
}

export function onProgress(state: CacheInstallationState, message: CacheMessage) {
    trace.info('[SW Client] Progress');
    state.resourcesCached++;
}

export function onError(windowObj: Window, state: CacheInstallationState, message: CacheMessage) {
    trace.warn('[SW Client] Error: ' + message.error);
    updateCacheDiagnostics(windowObj, state, CacheStatus.CacheFailed, message.cacheVersion);
    logServiceWorkerOptics(
        state,
        'ER',
        message.cacheVersion,
        message.error,
        message.resource,
        message.status,
        message.stack
    );
}

export function onCached(windowObj: Window, state: CacheInstallationState, message: CacheMessage) {
    trace.info('[SW Client] Cached');
    updateCacheDiagnostics(windowObj, state, CacheStatus.CacheInstalled, message.cacheVersion);
    logServiceWorkerOptics(state, 'C', message.cacheVersion);
}

export function onNoUpdate(
    windowObj: Window,
    state: CacheInstallationState,
    message: CacheMessage
) {
    trace.info('[SW Client] NoUpdate');
    updateCacheDiagnostics(windowObj, state, CacheStatus.CacheInstalled, message.cacheVersion);
    logServiceWorkerOptics(state, 'NU', message.cacheVersion);
}

export function onObsolete(
    windowObj: Window,
    state: CacheInstallationState,
    message: CacheMessage
) {
    trace.info('[SW Client] Obsolete');
    updateCacheDiagnostics(windowObj, state, CacheStatus.CacheCleared, null);
    logServiceWorkerOptics(state, 'OB');

    // Re-attempt to install the cache after cleaning the old caches
    if (state.cacheHealth > CacheHealth.Normal) {
        state.cacheHealth = CacheHealth.Normal;
        installServiceWorkerCache();
    }
}

export function onUpdateReady(
    windowObj: Window,
    state: CacheInstallationState,
    message: CacheMessage
) {
    trace.info('[SW Client] UpdateReady');
    updateCacheDiagnostics(windowObj, state, CacheStatus.CacheInstalled, message.cacheVersion);
    logServiceWorkerOptics(state, 'UR', message.cacheVersion);
}

export function onIdle(message: CacheMessage) {
    trace.info('[SW Client] Idle');
}

export function onUnCached(message: CacheMessage) {
    trace.info('[SW Client] Uncached');
}

export function onCleanupError(state: CacheInstallationState, message: CacheMessage) {
    trace.warn('[SW Client] Cleanup Error');
    state.cacheCleanupStatus = 1;
}

export function onCleanupSuceeded(state: CacheInstallationState, message: CacheMessage) {
    let prunedCaches: string =
        message.cachesCleaned != null ? message.cachesCleaned.join(',') : null;
    trace.info('[SW Client] Cleanup Suceeded, ' + prunedCaches);
    state.cacheCleanupStatus = 2;
    state.numberOfCachesCleaned = message.cachesCleaned != null ? message.cachesCleaned.length : 0;
}
